/** Late community moderation events must not redirect or close a newer private call. */
export function voiceModerationApplies(roomId:string|undefined,detail:{roomId?:string;fromRoomId?:string;communityId?:string},communities:{id:string;channels:{id:string}[]}[],move=false){
 if(!roomId)return false;
 const source=detail.fromRoomId||(!move?detail.roomId:undefined);
 if(source&&source!==roomId)return false;
 if(detail.communityId&&!communities.some(c=>c.id===detail.communityId&&c.channels.some(ch=>ch.id===roomId)))return false;
 return true;
}
